import { api } from './api';

export interface Pedido {
  id: number;
  idFornecedor: number;
  nomeFornecedor: string;
  dataDoPedido: string;
  dataPedidoString: string;
  dataPrevistaEntrega: string;
  dataPrevistaEntregaString: string;
  valorPedido: number;
  valorFrete: number;
  tipoFrete: string;
  quantidade: number;
}

export interface PedidoRequest {
  id?: number;
  idFornecedor: number;
  dataDoPedido: string;
  dataPrevistaEntrega: string;
  valorPedido: number;
  valorFrete: number;
  tipoFrete: string;
}

export interface ProdutoPedido {
  id?: number;
  idPedido: number;
  idProduto: number;
  nomeProduto: string;
  referencia: string;
  quantidade: number;
  valorUnitario: number;
  valorTotal: number;
  grade: string;
}

export interface PagamentoPedido {
  id?: number;
  idPedido: number;
  formaPagamento: string;
  valor: number;
  dataPagamento: string;
}

export const pedidoService = {
  getAll: async (): Promise<Pedido[]> => {
    const response = await api.get('/api/Pedido/GetAll');
    return response.data;
  },

  getAllTable: async (): Promise<Pedido[]> => {
    const response = await api.get('/api/Pedido/GetAllTable');
    return response.data;
  },

  getById: async (id: number): Promise<Pedido> => {
    const response = await api.get(`/api/Pedido/GetById?id=${id}`);
    return response.data;
  },

  save: async (pedido: PedidoRequest, produtos: ProdutoPedido[], pagamentos: PagamentoPedido[]): Promise<void> => {
    await api.post('/api/Pedido/Salvar', { pedido, produtos, pagamentos });
  },

  update: async (pedido: PedidoRequest, produtos: ProdutoPedido[], pagamentos: PagamentoPedido[]): Promise<void> => {
    await api.post('/api/Pedido/Alterar', { pedido, produtos, pagamentos });
  }
};
